// extracted by mini-css-extract-plugin
export var claims = "claims__o1Ev";
export var fakeClaims = "fakeClaims__q01j";
export var fakeFirmName1 = "fakeFirmName1__FOyA";
export var fakeFirmName2 = "fakeFirmName2__MuJm";
export var fakeFirmsCount = "fakeFirmsCount__uZbb";
export var fakeIcons = "fakeIcons__sZsc";
export var fakePosition = "fakePosition__DJh6";
export var fakeRecs = "fakeRecs__cLia";
export var firmInfo = "firmInfo__cOnY";
export var firmsContainer = "firmsContainer__HR4w";
export var icons = "icons__JE9R";
export var position = "position__Xzio";
export var recs = "recs__wrMk";
export var rowsContainer = "rowsContainer__NS7p";
export var shape = "shape__vnp8";